<div class="w-full h-screen flex flex-col items-center justify-center">
    <span class="w-full text-center text-[24px] mb-6 font-semibold text-primary-800">Update in Progress</span>
    <div class="flex flex-col gap-[40px]">
        <div class="servers">
            <img id="bg" alt="maintenance" width="248" height="180" ngSrc="assets/icons/maintenance-bg.svg" priority>
            <img id="wrench" alt="maintenance" width="78" height="78" ngSrc="assets/icons/wrench.svg" priority>
        </div>
        <div class="w-full">
            <div class="w-full text-center font-medium text-[16px] text-neutral-800">We’re currently updating the system
                to enhance your
                experience.
            </div>
            <div class="w-full text-center text-neutral-700 text-[14px]">
                The process will be completed shortly. Your page will refresh automatically once the update<br> is done,
                and
                you’ll be redirected to where you left off.<br>
                Thank you for your patience and understanding.<br>
            </div>
        </div>
    </div>
    <img id="logo" alt="atozcrm" ngSrc="assets/logo-v2.svg" height="25" width="100" priority>
</div>

